module.exports = __webpack_public_path__ + "fonts/ChivasLoud_Rg.030bd22d.ttf";